





import eva_logo from './../media/img/evalys_logo.png'
import eva_model_nb from './../media/img/eva-model-nb.png'
import eva_model from './../media/img/eva-model.jpg'

import twitter from './../media/img/twitter.png'
import pump from './../media/img/pump.png'

import eva_home_bg_2 from './../media/img/Landing_page_bg_moving_2.mp4'
import eva_logo_green from './../media/img/evalys_logo_green.png'
import x_icon from './../media/img/x-icon.png'

import ft1 from './../media/img/ft1.png'
import ft2 from './../media/img/ft2.png'
import ft3 from './../media/img/ft3.png'
import ft4 from './../media/img/ft4.png'

import ev_logo_single from './../media/img/evalys_logo_green.png'




export const images = {

    general: {
        
        eva_logo,
        
        ev_logo_single,

        eva_home_bg_2,
        eva_logo_green,
        x_icon,
        ft1,
        ft2,
        ft3,
        ft4,
    },

    brand_logos: {
        twitter,
        pump,
    },

    sidebar: {
    },

    home: {
        // lsm
    },

    wellness: {
        
    },

}